import { Component, type ReactNode } from "react";
import { Link } from "react-router-dom";

/** Keep a failed data query from leaving the entire signed-in app blank. */
export class PageErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <section className="money-page money-page-error" role="alert" aria-labelledby="page-error-title">
      <p className="eyebrow">Page unavailable</p><h1 id="page-error-title">This view could not load</h1>
      <p>Your saved records have not changed. Reload this page to try again, or check the daily brief for the latest published status.</p>
      <div className="money-error-actions"><button type="button" className="money-primary" onClick={() => window.location.reload()}>Reload page</button><Link to="/agent">Open daily brief</Link></div>
    </section>;
  }
}
